import "reflect-metadata";
import {inject, injectable} from "inversify";
import {IoRepository} from "@dropDesk/domain/repositories/io/io.repository";

@injectable()
export class GetMediaStreamUseCase {
  private _repository: IoRepository;

  constructor(@inject(IoRepository) repository: IoRepository) {
    this._repository = repository;
  }

  public call(): Promise<MediaStream> {
    return this._repository.getMediaStream();
  }
}
